import type {SelectedServer, SelectedOrganization} from './types'

export class AllowlistDialogState {
  #addedServers: SelectedServer[] = []
  #currentSelectedServer: SelectedServer | null = null
  #selectedOrganizations: SelectedOrganization[] = []

  get addedServers(): readonly SelectedServer[] {
    return this.#addedServers
  }

  get currentSelectedServer(): SelectedServer | null {
    return this.#currentSelectedServer
  }

  get selectedOrganizations(): readonly SelectedOrganization[] {
    return this.#selectedOrganizations
  }

  setCurrentSelectedServer(server: SelectedServer | null): void {
    this.#currentSelectedServer = server
  }

  addServer(server: SelectedServer): boolean {
    const alreadyAdded = this.#addedServers.some(s => s.id === server.id)
    if (!alreadyAdded) {
      this.#addedServers.push({...server})
      return true
    }
    return false
  }

  removeServerAtIndex(index: number): boolean {
    if (index >= 0 && index < this.#addedServers.length) {
      this.#addedServers.splice(index, 1)
      return true
    }
    return false
  }

  addOrganization(org: SelectedOrganization): void {
    if (!this.#selectedOrganizations.some(o => o.id === org.id)) {
      this.#selectedOrganizations.push({...org})
    }
  }

  removeOrganization(orgId: string): void {
    const index = this.#selectedOrganizations.findIndex(o => o.id === orgId)
    if (index >= 0) {
      this.#selectedOrganizations.splice(index, 1)
    }
  }

  reset(): void {
    this.#addedServers.length = 0
    this.#currentSelectedServer = null
    this.#selectedOrganizations.length = 0
  }
}

// Global state instance — needed because delegated-events handlers share state
let dialogState: AllowlistDialogState | null = null

export function getDialogState(): AllowlistDialogState {
  if (!dialogState) {
    dialogState = new AllowlistDialogState()
  }
  return dialogState
}

export function resetDialogState(): void {
  if (dialogState) {
    dialogState.reset()
  }
}
